/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

$(document).on("turbo:load", () => new window.App.Components.ytPlayerWithGaTracking())

window.App.Components.ytPlayerWithGaTracking = class ytPlayerWithGaTracking {
  constructor() {
    this.getPlayerPercentageViewed = this.getPlayerPercentageViewed.bind(this)
    this.debug = true
    this.bindElements()
    this.setupYoutubePlayer()
  }

  bindElements() {
    $(document).on("click", '[data-track-on="click"]', e => {
      const toTrack = $(e.currentTarget)
      if (!toTrack.hasClass("tracked")) {
        this.trackNewEvent(
          toTrack.data("track-category"),
          toTrack.data("track-action"),
          toTrack.data("track-label")
        )
        if (toTrack.data("track-once") === true) {
          return toTrack.addClass("tracked")
        }
      }
    })

    $(document).on("change", '[type="checkbox"][data-track-on="change"]', e => {
      const toTrack = $(e.currentTarget)
      const checked = toTrack.prop("checked") ? "true" : "false"
      if (!toTrack.hasClass("tracked")) {
        this.trackNewEvent(
          toTrack.data("track-category"),
          toTrack.data(`track-action-${checked}`),
          toTrack.data("track-label")
        )
        if (toTrack.data("track-once") === true) {
          return toTrack.addClass("tracked")
        }
      }
    })

    $(document).on("focus", '[data-track-on="focus"]', e => {
      const toTrack = $(e.currentTarget)
      if (!toTrack.hasClass("tracked")) {
        this.trackNewEvent(
          toTrack.data("track-category"),
          toTrack.data("track-action"),
          toTrack.data("track-label")
        )
        if (toTrack.data("track-once") === true) {
          return toTrack.addClass("tracked")
        }
      }
    })

    $(document).on("keyup", '[data-track-on="keyup"]', e => {
      const toTrack = $(e.currentTarget)
      if (!toTrack.hasClass("tracked")) {
        this.trackNewEvent(
          toTrack.data("track-category"),
          toTrack.data("track-action"),
          toTrack.data("track-label")
        )
        if (toTrack.data("track-once") === true) {
          return toTrack.addClass("tracked")
        }
      }
    })

    $(document).on("submit", '[data-track-on="submit"]', e => {
      const toTrack = $(e.currentTarget)
      if (!toTrack.hasClass("tracked")) {
        this.trackNewEvent(
          toTrack.data("track-category"),
          toTrack.data("track-action"),
          toTrack.data("track-label")
        )
        if (toTrack.data("track-once") === true) {
          return toTrack.addClass("tracked")
        }
      }
    })

    // Trigger track Dig Deeper inner links
    $(document).on("click", ".more_text a", e => {
      const toTrack = $(e.currentTarget)
      $(".dig-deeper-link-trigger").data(
        "track-action",
        "outbound click - " + toTrack.attr("href")
      )
      return $(".dig-deeper-link-trigger").click()
    })

    return $("body").on("translatePage", jqEvent => {
      const { originalEvent: e } = jqEvent
      const lang = e != null && e.detail != null && e.detail.lang

      if (!lang) {
        return
      }

      this.player.destroy()
      return this.loadPlayer({
        cc_lang_pref: lang,
        cc_load_policy: 1,
      })
    })
  }

  trackNewEvent(category, action, label) {
    if (label === undefined) {
      label = ""
    }
    if (this.inDebugMode()) {
      console.log(
        "ga('send', 'event', '" +
          category +
          "', '" +
          action +
          "', '" +
          label +
          "')"
      )
    }
    return ga("send", "event", category, action, label)
  }

  setupYoutubePlayer() {
    if (
      (typeof YT !== "undefined" && YT !== null ? YT.Player : undefined) != null
    ) {
      return this.loadPlayer()
    } else {
      window.onYouTubeIframeAPIReady = () => {
        return this.loadPlayer()
      }

      const hostUrl = "https://www.youtube.com/iframe_api"

      const tag = document.createElement("script")
      tag.src = hostUrl
      const firstScriptTag = document.getElementsByTagName("script")[0]
      return firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
    }
  }

  loadPlayer(playerVars) {
    if (playerVars == null) {
      playerVars = {}
    }
    const data = $("#playerContainer").data()
    if (data != null) {
      const { lessonId } = data
      const { videoId } = data
      this.timelineMarker = 0
      this.videoPlaybackQuality = "medium"

      const playerDefaultVars = {
        rel: 0,
        modestbranding: 1,
        wmode: "transparent",
        start: data.videoStart,
        end: data.videoEnd,
      }

      const player = new YT.Player("playerContainer", {
        height: "360",
        width: "640",
        playerVars: $.extend({}, playerDefaultVars, playerVars),
        videoId,
        events: {
          onReady(event) {
            return new App.Components.YoutubeVideoSeekTo({
              player: event.target,
              selector: "[data-seek-to]",
            })
          },

          // we can get current time with player.getCurrentTime()
          onStateChange: event => {
            const lessonsAll = new App.lessonsAll()
            switch (event.data) {
              case YT.PlayerState.PLAYING:
                $(document).trigger("VideoPlayer::started", event.target)

                this.checkTimeline(true, event, videoId, lessonId)
                this.trackNewEvent(
                  "video",
                  "initiate",
                  `${videoId}|${lessonId}`
                )
                return lessonsAll.logView()
              case YT.PlayerState.PAUSED:
                this.checkTimeline(false, event)
                return $(document).trigger("VideoPlayer::paused", event.target)
              case YT.PlayerState.ENDED:
                if ($(".lessonsShowView").length !== 0) {
                  lessonsAll.nextPanel(null, "videoState")
                }
                $(document).trigger("VideoPlayer::ended", event.target)
                return lessonsAll.logEnded()
            }
          },
        },
      })
      $("#playerContainer").parent().fitVids()

      return (this.player = player)
    }
  }

  checkTimeline(flag, event, videoId, lessonId) {
    const self = this
    if (flag === true) {
      return (this.timer = setInterval(
        () => self.getPlayerPercentageViewed(event, videoId, lessonId),
        1200
      ))
    } else {
      return clearInterval(this.timer)
    }
  }

  getPlayerPercentageViewed(event, videoId, lessonId) {
    const currentTime = event.target.getCurrentTime()
    const videoDuration = event.target.getDuration()
    const currentViewedPercentage = Math.round(
      (currentTime / videoDuration) * 100
    )
    const currentVideoPlaybackQuality = event.target.getPlaybackQuality()

    // Trigger tracking if video playback enters or exits fullscreen mode
    if (this.videoPlaybackQuality !== currentVideoPlaybackQuality) {
      this.trackNewEvent(
        "video",
        "fullscreen",
        currentVideoPlaybackQuality === "medium" ? "exit" : "enter"
      )
      this.videoPlaybackQuality = currentVideoPlaybackQuality
    }

    // Trigger tracking at specific points in timeline
    if (_.contains([50, 75], currentViewedPercentage)) {
      if (this.timelineMarker !== currentViewedPercentage) {
        this.trackNewEvent(
          "video",
          `${currentViewedPercentage}%`,
          `${videoId}|${lessonId}`
        )
      }
      this.timelineMarker = currentViewedPercentage
      if (this.timelineMarker === 100) {
        return clearInterval(this.timer)
      }
    }
  }

  // Convenience method
  inDebugMode() {
    return this.debug === true
  }
}
